var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTestIcon = function SvgTestIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.29 7.876 7.938 3.538v10.33l-7.939-3.538zM21.17 7.808l-7.938 3.538v10.33l7.939-3.538zM20.318 6.426l-7.911-3.513-8.035 3.605 7.911 3.513z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTestIcon);
export { ForwardRef as ReactComponent };